import { linklistApi } from '@/utils/axios-config';

export default {
    get(tree_slug) {
        return linklistApi.get(`/link-trees/${tree_slug}`);
    },
    create(organisation_slug, data) {
        return linklistApi.post(
            `/organisations/${organisation_slug}/link-trees`,
            data,
        );
    },
    delete(tree_slug) {
        return linklistApi.delete(`/link-trees/${tree_slug}/`);
    },
    update(tree_slug, data) {
        return linklistApi.put(`/link-trees/${tree_slug}/`, data);
    },
    getStats(tree_slug, data) {
        let paramString = Object.entries(data)
            .map(([key, val]) => `${key}=${val}`)
            .join('&');
        return linklistApi.get(`/link-trees/${tree_slug}/stats?${paramString}`);
    },
    getOverviewStats(tree_slug, data) {
        let paramString = Object.entries(data)
            .map(([key, val]) => `${key}=${val}`)
            .join('&');
        return linklistApi.get(
            `/link-trees/${tree_slug}/stats/overview?${paramString}`,
        );
    },
    getLinkStats(tree_slug, data) {
        let paramString = Object.entries(data)
            .map(([key, val]) => `${key}=${val}`)
            .join('&');
        return linklistApi.get(
            `/link-trees/${tree_slug}/stats/links?${paramString}`,
        );
    },
    applyChanges(tree_slug) {
        return linklistApi.post(`/link-trees/${tree_slug}/apply_changes`);
    },
    discardChanges(tree_slug) {
        return linklistApi.post(`/link-trees/${tree_slug}/revert_changes`);
    },
    publicTree(tree_slug) {
        return linklistApi.get(`/public/link-trees/${tree_slug}`);
    },
};
